import React from 'react';
import {
  BLADE_PATHS,
  LOGO_BLADES,
  LOGO_CANVAS_PX,
  LOGO_DOTS,
  restingDot,
} from './assistantMark.data';

export type AssistantIconProps = {
  /** Rendered size in px. */
  size?: number;
  /** Defaults to `currentColor`, so `text-*` utilities colour the mark. */
  color?: string;
  className?: string;
};

// The centre dot settles at 5% scale behind the blades: never visible.
const VISIBLE_DOTS = LOGO_DOTS.map(dot => ({
  node: dot.node,
  ...restingDot(dot),
})).filter(dot => dot.r >= 1);

/** The pinwheel mark on the final frame `AnimatedAssistantIcon` builds to. */
const AssistantIcon: React.FC<AssistantIconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${LOGO_CANVAS_PX} ${LOGO_CANVAS_PX}`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden>
    {/* Blades paint below the dots, matching the Figma layer order. */}
    {LOGO_BLADES.map(blade => (
      <path
        key={blade.node}
        d={BLADE_PATHS[blade.slug]}
        transform={`translate(${blade.left + blade.toX} ${
          blade.top + blade.toY
        })`}
      />
    ))}
    {VISIBLE_DOTS.map(dot => (
      <circle
        key={dot.node}
        cx={dot.cx}
        cy={dot.cy}
        r={dot.r}
        opacity={dot.opacity}
      />
    ))}
  </svg>
);

export default AssistantIcon;
